import { Accordion, AccordionDetails, Grid, useTheme } from '@mui/material'

import useStyles from '../index.styles'

import AccordionGroup from './accordion-group'
import DeviceItem from './device-item'

const AccordionGroupFloor = ({
  building,
  floor,
  floorKey,
  isExpanded,
  onToggle,
}: {
  building: IBuildingGroup
  floor: IFloorGroup
  floorKey: string
  isExpanded: boolean
  onToggle: (floorKey: string) => (event: React.SyntheticEvent, newExpanded: boolean) => void
}) => {
  const classes = useStyles
  const theme = useTheme()

  if (!building.anyHasFloor) {
    return (
      <Grid container={true} size={12} columnSpacing={1} rowSpacing={1} sx={classes.accordionDeviceContainer}>
        {floor.devices.map((device) => (
          <DeviceItem key={device.node.id} device={device} />
        ))}
      </Grid>
    )
  }

  return (
    <Accordion
      data-testid="floor-accordion"
      expanded={isExpanded}
      onChange={(event, newExpanded) => {
        event.stopPropagation()
        onToggle(floorKey)(event, newExpanded)
      }}
      sx={[classes.accordion, classes.secondLevelAccordion(theme)]}
    >
      <AccordionGroup.SummaryNested label={floor.name === 'No Floor Assigned' ? floor.name : `Floor ${floor.name}`} count={floor.devices.length} />
      <AccordionDetails sx={classes.accordionDetails}>
        <Grid container={true} size={12} columnSpacing={1} rowSpacing={1} sx={classes.accordionDeviceContainer}>
          {floor.devices.map((device) => (
            <DeviceItem key={device.node.id} device={device} />
          ))}
        </Grid>
      </AccordionDetails>
    </Accordion>
  )
}

export default AccordionGroupFloor
